import { render, staticRenderFns } from "./details-panel.vue?vue&type=template&id=849bfd76&scoped=true&"
import script from "./details-panel.vue?vue&type=script&lang=ts&"
export * from "./details-panel.vue?vue&type=script&lang=ts&"
import style0 from "./details-panel.vue?vue&type=style&index=0&id=849bfd76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "849bfd76",
  null
  
)

export default component.exports